import React from 'react';
import { BrowserRouter } from "react-router-dom";
import { Grid } from 'semantic-ui-react';
import SiteHeader from "./SiteLayout/SiteHeader";
import Routes from "./Routes";
import Footer from "./SiteLayout/Footer";
import ScrollToTop from "./SiteLayout/ScrollToTop";
import "./SiteLayout/Site.css";

const App = () => (
  <BrowserRouter>
    <ScrollToTop>
      <SiteHeader />
      <Grid container> 
        <Grid.Row>
          <Grid.Column>
            <Routes />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Footer />
    </ScrollToTop>
  </BrowserRouter>
)
export default App;
